import { createElement, forwardRef } from "react";
import { m, useReducedMotion } from "framer-motion";
import { hoverCard, hoverTransition } from "../../../utils/motionVariants";
import { getMotionComponent, resolveTag } from "./motionPrimitives";

/**
 * Premium card hover — transform only (y + scale). Shadow via CSS classes.
 */
const HoverCard = forwardRef(function HoverCard(
  { as = "div", className = "", children, ...props },
  ref
) {
  const reduceMotion = useReducedMotion();
  const tag = resolveTag(as);
  const mergedClassName = [
    className,
    "transition-shadow duration-300 ease-out",
  ]
    .filter(Boolean)
    .join(" ");

  if (reduceMotion) {
    return createElement(tag, { ref, className: mergedClassName, ...props }, children);
  }

  const Component = getMotionComponent(m, tag);

  return createElement(
    Component,
    {
      ref,
      initial: "rest",
      whileHover: "hover",
      variants: hoverCard,
      transition: hoverTransition,
      className: mergedClassName,
      ...props,
    },
    children
  );
});

HoverCard.displayName = "HoverCard";

export default HoverCard;
